import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import clsx from 'clsx'

import { CountryOption, Modal } from '@makyoapp/makyo-ui'

import { getLanguageList, Language } from '@/lib/language-flag'

export interface LanguageModalProps {
  show: boolean
  onHide?: () => void
  excludeLanguages?: Language[]
  onSelect?: (lng: Language) => void
  title?: React.ReactNode
  isLoading?: boolean
}

export function LanguageModal({ show, onHide, excludeLanguages = [], onSelect, isLoading, title }: LanguageModalProps) {
  const { t } = useTranslation()
  const [search, setSearch] = useState('')

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header onCloseClick={onHide}>{title || <Trans>Select Languages</Trans>}</Modal.Header>
      <Modal.Search
        placeholder={t('Search')}
        value={search}
        onChange={(search) => setSearch(search || '')}
        onClear={() => setSearch('')}
      />
      <Modal.Body noPadding className='relative'>
        {isLoading && (
          <div className='flex-cc h-[40vh] absolute inset-0 bg-black/20'>
            <span className='loading' />
          </div>
        )}
        <div className='p-2 h-[40vh] flex flex-col overflow-y-scroll'>
          {getLanguageList()
            .filter((l) => {
              if (!excludeLanguages.find((o) => o.name === l.name)) {
                return [l.name, l.country, Object.values(l.ids).join(' ')].join(' ').toLowerCase().includes(search)
              } else {
                return false
              }
            })
            .map((lng, idx) => {
              return (
                <button
                  onClick={() => {
                    onSelect?.(lng)
                  }}
                  key={idx}
                  className={clsx('px-2 py-1 dark:hover:bg-slate-600 hover:bg-zinc-200 flex-c')}
                >
                  <CountryOption slug={lng.countryCode} name={lng.name} className='w-full' />
                </button>
              )
            })}
        </div>
      </Modal.Body>
    </Modal>
  )
}

export function LanguageDropdown({
  show,
  onHide,
  excludeLanguages = [],
  onSelect,
  isLoading,
  title,
}: LanguageModalProps) {
  const { t } = useTranslation()
  const [search, setSearch] = useState('')

  return (
    <div>
      <Modal.Header onCloseClick={onHide}>{title || <Trans>Select Languages</Trans>}</Modal.Header>
      <Modal.Search
        placeholder={t('Search')}
        value={search}
        onChange={(search) => setSearch(search || '')}
        onClear={() => setSearch('')}
      />
      <div className='relative'>
        {isLoading && (
          <div className='flex-cc h-[40vh] absolute inset-0 bg-black/20'>
            <span className='loading' />
          </div>
        )}
        <div className='p-2 h-[40vh] flex flex-col overflow-y-scroll'>
          {getLanguageList()
            .filter((l) => {
              if (!excludeLanguages.find((o) => o.name === l.name)) {
                return [l.name, l.country, Object.values(l.ids).join(' ')]
                  .join(' ')
                  .toLowerCase()
                  .includes(search.toLowerCase())
              } else {
                return false
              }
            })
            .map((lng, idx) => {
              return (
                <button
                  onClick={() => {
                    onSelect?.(lng)
                  }}
                  key={idx}
                  className={clsx('px-2 py-1 dark:hover:bg-slate-600 hover:bg-zinc-200 flex-c')}
                >
                  <CountryOption slug={lng.countryCode} name={lng.name} className='w-full' />
                </button>
              )
            })}
        </div>
      </div>
    </div>
  )
}
